export const CustomApiEndpoint = {
  fetchReservationAllList: '/user-reservations/all', // GET: 예약 현황 조회 (단체 포함 , 아리지전용)
  fetchReservationGroupList: '/user-reservations/group',
};
